import { render, staticRenderFns } from "./ColorChip.vue?vue&type=template&id=3d83f136&scoped=true&"
import script from "./ColorChip.vue?vue&type=script&lang=js&"
export * from "./ColorChip.vue?vue&type=script&lang=js&"
import style0 from "./ColorChip.vue?vue&type=style&index=0&id=3d83f136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d83f136",
  null
  
)

export default component.exports